/**
 * Composant pour afficher une carte de rendez-vous (style ligne)
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Appointment } from '../types';
import { 
  formatDate, 
  formatTime, 
  getStatusLabel, 
  getStatusColor,
  getSimplifiedEmailStatus,
  getSimplifiedSMSStatus,
  getEmailPastilleClass,
  getSMSPastilleClass
} from '../utils/statusUtils';

interface AppointmentCardProps {
  appointment: Appointment;
  showContactInfo?: boolean;
  showTypeInfo?: boolean;
}

/**
 * Composant pour afficher une carte de rendez-vous (style ligne)
 */
const AppointmentCard: React.FC<AppointmentCardProps> = ({ 
  appointment, 
  showContactInfo = false, 
  showTypeInfo = true
}) => {
  // Calculer les statuts simplifiés et les classes CSS pour les pastilles
  const simplifiedEmail = getSimplifiedEmailStatus(appointment.email_status);
  const emailPastilleClass = getEmailPastilleClass(simplifiedEmail);

  const simplifiedSMS = getSimplifiedSMSStatus(appointment.sms_status);
  const smsPastilleClass = getSMSPastilleClass(simplifiedSMS);

  return (
    <div key={appointment.id} className="appointment-card appointment-row"> 
      
      {/* Colonne Patient */}
      <div className="appointment-cell patient-info">
        {/* Nom du patient */}
        <div className="patient-name">
           {appointment.gender === 'M' ? 'M.' : 'Mme'} {appointment.name} {appointment.surname}
        </div>
        {/* Date/Heure */}
        <div className="patient-datetime-info"> 
          <span>{formatDate(appointment.date)}</span>
          <span className="time-separator"> à </span> 
          <span>{formatTime(appointment.time)}</span>
        </div>
        {/* Informations de contact (si affichées) */}
        {showContactInfo && (
           <div className="patient-contact-details">
             {appointment.phone && <span>{appointment.phone}</span>}
             {appointment.email && <span>{appointment.email}</span>}
           </div>
        )}
      </div>

      {/* Colonne Type (si affiché) */}
      {showTypeInfo && (
        <div className="appointment-cell type-info">
          {appointment.type}
        </div>
      )}
      
      {/* Cellule pour les badges de communication */}
      <div className="appointment-cell communication-status-badges">
        {/* Badge Email */}
        <span 
          className={`comm-badge-button ${emailPastilleClass}`}
          title={`Statut Email: ${simplifiedEmail}`}
        >
          Email: {simplifiedEmail}
        </span>
        {/* Badge SMS */}
        <span 
          className={`comm-badge-button ${smsPastilleClass}`}
          title={`Statut SMS: ${simplifiedSMS}`}
        >
          SMS: {simplifiedSMS}
        </span>
      </div>

      {/* Colonne Actions */}
      <div className="appointment-cell action-cell">
        <Link to={`/appointments/${appointment.id}`} className="btn btn-secondary btn-sm">
          Détails
        </Link>
      </div>
    </div>
  );
};

export default AppointmentCard;
